import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { ToastModel } from "../../models/ToastModel";
import { AlertColor } from "@mui/material/Alert";
import ToastSlice from "../slices/ToastSlice";
import { RootState } from "../store";

export const ToastActions = ToastSlice.actions;
export const addDisplayToast = (
  data: (msg: string, variant?: AlertColor) => void
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(ToastActions.addDisplayToast(data));
  };
};
export const showToast = (
  data: ToastModel
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(ToastActions.showToast(data));
  };
};
